<template>
    <div class="home-swiper">
        <!-- 轮播容器：仅保留核心轮播轨道与项 -->
        <div class="swiper-container">
            <div class="swiper-track" 
                 :style="{ 
                   transform: `translateX(-${currentPosition * 100}%)`,
                   transition: transitionDuration 
                 }">
                <!-- 动态渲染displayList（始终2个元素：当前项+下一项） -->
                <div class="swiper-slide" v-for="(item, index) in displayList" :key="index">
                    <!-- 图片类型轮播项 -->
                    <div class="slide-content" v-if="item.img">
                        <img :src="item.img" :alt="item.alt || '轮播内容'" class="content-img">
                    </div>
                    <!-- 产品类型轮播项（带5张产品图） -->
                    <div class="slide-content producets-img" v-if="item.type">
                        <div class="swper-list">
                            <img src="https://youke1.picui.cn/s1/2025/08/28/68b0624a44254.png" class="products-1 products" alt="">
                            <img src="https://youke1.picui.cn/s1/2025/08/28/68b0624a9f620.png" class="products-2 products" alt="">
                            <img src="https://youke1.picui.cn/s1/2025/08/28/68b0644f1692a.png" class="products-3 products" alt="">
                            <img src="https://youke1.picui.cn/s1/2025/08/28/68b0624a8328a.png" class="products-4 products" alt="">
                            <img src="https://youke1.picui.cn/s1/2025/08/28/68b0624a5a901.png" style="margin-right: 100px;" class="products-5 products" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 左右控制按钮：保留禁用状态防误触 -->
        <img src="https://youke1.picui.cn/s1/2025/08/27/68af0900e0b9e.png" 
             class="control-btn left-btn" 
             alt="上一页"
             @click="prevSlide"
             :disabled="isProcessing">
        <img src="https://youke1.picui.cn/s1/2025/08/27/68af0900d4f3f.png" 
             class="control-btn right-btn" 
             alt="下一页"
             @click="nextSlide"
             :disabled="isProcessing">
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineProps, watch } from 'vue'

// 1. 仅接收父组件必要参数：轮播数据源goodList
const props = defineProps({
    goodList: {
        type: Array,
        default: () => [],
        required: true // 确保父组件必传数据源
    }
})

// 2. 核心状态定义（无冗余，仅保留轮播必需）
const originalList = ref([...props.goodList]) // 原始数据源（不直接修改，用于备份）
const displayList = ref([])                   // 动态显示数组（始终存2个元素：当前+下一个）
const currentIndex = ref(0)                   // 原始数组的当前索引（用于计算下一项）
const currentPosition = ref(0)                // 轮播切换位置（0=当前页，1=切换中）
const transitionDuration = ref('transform 0.5s ease-out') // 滑动动画时长
const isProcessing = ref(false)               // 切换锁：防止快速连续点击
let timer = ref(null)                         // 自动播放定时器（默认关闭）

// 3. 初始化显示数组：加载"当前项+下一项"
const initDisplayList = () => {
    if (originalList.value.length === 0) return
    displayList.value = [
        originalList.value[currentIndex.value], // 当前要显示的项
        // 下一项（循环取：最后一项的下一项是第一项）
        originalList.value[(currentIndex.value + 1) % originalList.value.length]
    ]
}

// 4. 右滑逻辑（下一页）：第一个元素移到最后
const nextSlide = () => {
    // 防误触：切换中/只有1项时不执行
    if (isProcessing.value || originalList.value.length <= 1) return
    isProcessing.value = true

    // 步骤1：触发右滑动画（移到"下一项"位置）
    transitionDuration.value = 'transform 0.5s ease-out'
    currentPosition.value = 1

    // 步骤2：动画结束后调整数组（无缝切换核心）
    setTimeout(() => {
        // 更新原始数组索引（循环）
        currentIndex.value = (currentIndex.value + 1) % originalList.value.length
        // 删除displayList第一个元素（已滑出的项）
        displayList.value.shift()
        // 添加新的"下一项"到displayList末尾
        displayList.value.push(originalList.value[(currentIndex.value + 1) % originalList.value.length])
        // 步骤3：无动画重置位置（回到"当前页"状态）
        transitionDuration.value = 'none'
        currentPosition.value = 0
        // 解锁切换
        isProcessing.value = false
    }, 500) // 等待动画结束（与动画时长一致）
}

// 5. 左滑逻辑（上一页）：最后一个元素移到最前
const prevSlide = () => {
    if (isProcessing.value || originalList.value.length <= 1) return
    isProcessing.value = true

    // 步骤1：无动画调整数组（先加载"前一项"）
    transitionDuration.value = 'none'
    // 更新原始数组索引（向前循环：第一项的前一项是最后一项）
    currentIndex.value = (currentIndex.value - 1 + originalList.value.length) % originalList.value.length
    // 在displayList开头添加"前一项"
    displayList.value.unshift(originalList.value[currentIndex.value])
    // 定位到"切换中"位置
    currentPosition.value = 1

    // 步骤2：强制DOM更新后触发左滑动画
    setTimeout(() => {
        transitionDuration.value = 'transform 0.5s ease-out'
        currentPosition.value = 0 // 滑回"当前页"位置

        // 步骤3：动画结束后清理多余元素
        setTimeout(() => {
            displayList.value.pop() // 删除displayList最后一个元素（已滑出的项）
            isProcessing.value = false // 解锁
        }, 500)
    }, 10) // 确保DOM先更新
}

// 6. 自动播放控制（默认关闭，与原逻辑一致）
const startAutoPlay = () => {
    if (originalList.value.length <= 1) return
    stopAutoPlay() // 防止重复创建定时器
    timer.value = setInterval(nextSlide, 5000) // 5秒自动切换一次
}
const stopAutoPlay = () => {
    if (timer.value) {
        clearInterval(timer.value)
        timer.value = null
    }
}

// 7. 监听父组件数据源变化：动态同步（如父组件更新goodList时）
watch(() => props.goodList, (newGoodList) => {
    originalList.value = [...newGoodList] // 同步新数据源
    currentIndex.value = 0 // 重置索引到第一项
    initDisplayList() // 重新初始化显示数组
})

// 8. 生命周期：初始化与清理
onMounted(() => {
    initDisplayList() // 组件挂载时加载初始数据
    // 如需启用自动播放，解开下方注释（原逻辑默认关闭）
    // if (originalList.value.length > 1) startAutoPlay()

    // 鼠标悬停暂停/离开恢复（如需自动播放则生效）
    const container = document.querySelector('.home-swiper')
    container.addEventListener('mouseenter', stopAutoPlay)
    container.addEventListener('mouseleave', () => {
        if (originalList.value.length > 1) startAutoPlay()
    })
})

onUnmounted(() => {
    stopAutoPlay() // 组件卸载时清理定时器
    const container = document.querySelector('.home-swiper')
    // container.removeEventListener('mouseenter', stopAutoPlay)
    // container.removeEventListener('mouseleave', startAutoPlay)
})
</script>

<style scoped>
/* 所有样式完全保留，未做任何修改（符合"样式别动"要求） */
.home-swiper {
    background-color: #F4ECE1;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.swiper-container {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.swiper-track {
    display: flex;
    height: 100%;
}

.swiper-slide {
    min-width: 100%;
    height: 100%;
    position: relative;
}

.slide-video {
    position: absolute;
    left: 30%;
    top: 50%;
    transform: translateY(-50%);
    height: 700px;
    width: 100%;
    z-index: 1;
}

.slide-video video {
    height: 100%;
    object-fit: cover;
}

.slide-content {
    position: absolute;
    z-index: 2;
}

.slid-title {
    position: absolute;
    color: #6A584E;
    font-size: 22px;
    width: 100%;
    text-align: center;
    top: 208px;
}

.content-img {
    height: 100%;
    width: 100vw;
}

.control-btn {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 43.5%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 100;
    transition: transform 0.3s ease;
}

.control-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: translateY(-50%) scale(1);
}

.control-btn:hover:not(:disabled) {
    transform: translateY(-50%) scale(1.1);
}

.left-btn {
    left: 40px;
}

.right-btn {
    right: 40px;
}

/* 以下为原指示器样式（保留不动，仅不渲染DOM） */
.swiper-indicators {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
    z-index: 100;
}

.swiper-indicators span {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(106, 88, 78, 0.5);
    cursor: pointer;
    transition: all 0.3s ease;
}

.swiper-indicators span.active {
    background-color: #6A584E;
    width: 30px;
    border-radius: 6px;
}

.producets-img {
    background: url("https://img.cdn1.vip/i/68b4419e00a8a_1756643742.webp") no-repeat;
    background-size: contain;
    background-position: left top;
    min-height: 300px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
}

.swper-list {
    display: flex;
    width: 70%;
    justify-content: flex-end;
    margin-left: auto;
    gap: 10px;
}

.products {
    width: 14vw;
    transition: transform 0.3s ease, z-index 0.3s ease;
}

.products:hover {
    transform: scale(1.2);
    z-index: 99999;
}
</style>